import React, { useState, useEffect } from "react";
import axios from "axios";
import "./SidePanel.scss";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


const SidePanel = ({ isOpen, onClose }) => {
  const [formData, setFormData] = useState({
    client_name: "",
    client_phone: "",
    technician_name: "",
    location: "",
    ticket_type: "Technical",
    ticket_priority: "Medium",
    ticket_feedback: "",
  });

  const [isSubmitting, setIsSubmitting] = useState(false);

  const [technicians, setTechnicians] = useState([]);
  const ticketTypes = ["Power Optimization" ,"New Installation", "Relocation", "Technical","Survey", "LOS"];
  const ticketPriorities = ["Low", "Medium", "High"];

  // Fetch technician options from API (if available)
  useEffect(() => {
    // Replace with your actual API endpoint
    
    axios.get("https://tickets-api-q5n6.onrender.com/api/technicians").then((response) => {
      setTechnicians(response.data); // Assuming API returns a list of technician names
    });
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault(); // Prevent default form submission
  
    // Validate input fields
    if (!formData.client_name || !formData.client_phone || !formData.technician_name || !formData.location) {
      toast.warning('Please fill in all required fields!');
      return;
    }
  
    const payload = {
      client_name: formData.client_name,
      client_phone: formData.client_phone,
      technician_name: formData.technician_name,
      location: formData.location,
      ticket_type: formData.ticket_type,
      ticket_priority: formData.ticket_priority,
      ticket_feedback: formData.ticket_feedback || "",
    };
  
    try {
      setIsSubmitting(true); // Show loading state
      const response = await axios.post("https://tickets-api-q5n6.onrender.com/api/new_ticket", payload);
  
      // Handle success
      if (response.status === 201 || response.status === 200) {
        toast.success('Ticket Created successfully!');
        setFormData({
          client_name: "",
          client_phone: "",
          technician_name: "",
          location: "",
          ticket_type: "New Installation",
          ticket_priority: "Medium",
          ticket_feedback: "",
        });
        onClose(); // Close the side panel
      } else {
        throw new Error("Unexpected response from the server.");
      }
    } catch (error) {
      // Handle error
      console.error("Error submitting ticket:", error.response || error.message);

      toast.error('Failed to create ticket. Please try again.');
      
      // alert(
      //   error.response?.data?.message ||
      //     "Failed to submit the ticket. Please try again."
      // );
    } finally {
      setIsSubmitting(false); // Hide loading state
    }
  };
  

  if (!isOpen) return null;

  return (
    <div className="side-panel scroll1">
      <div className="side-panel-header">
        <h2>New Ticket</h2>
        <button className="close-panel" onClick={onClose}>
          ✖
        </button>
      </div>
      <form className="ticket-form" onSubmit={handleSubmit}>
        <label>
          Client Name:
          <input
            type="text"
            name="client_name"
            value={formData.client_name}
            onChange={handleChange}
            placeholder="Enter client's name"
            required
          />
        </label>
        <label>
          Client Phone:
          <input
            type="tel"
            name="client_phone"
            value={formData.client_phone}
            onChange={handleChange}
            placeholder="Enter client's phone"
            required
          />
        </label>
        <label>
          Technician Name:
          <select
            name="technician_name"
            value={formData.technician_name}
            onChange={handleChange}
            required
          >
            <option value="">Select a technician</option>
            {technicians.map((tech) => (
              <option key={tech.id} value={tech.name}>
                {tech.name}
              </option>
            ))}
          </select>
        </label>

        <label>
          Location:
          <input
            type="text"
            name="location"
            value={formData.location}
            onChange={handleChange}
            placeholder="Enter location"
            required
          />
        </label>
        <label>
          Ticket Type:
          <select
            name="ticket_type"
            value={formData.ticket_type}
            onChange={handleChange}
            required
          >
            {ticketTypes.map((type, index) => (
              <option key={index} value={type}>
                {type}
              </option>
            ))}
          </select>
        </label>
        <label>
          Ticket Priority:
          <select
            name="ticket_priority"
            value={formData.ticket_priority}
            onChange={handleChange}
            required
          >
            {ticketPriorities.map((priority, index) => (
              <option key={index} value={priority}>
                {priority}
              </option>
            ))}
          </select>
        </label>
        <label>
          Ticket Feedback (Optional):
          <textarea
            name="ticket_feedback"
            value={formData.ticket_feedback}
            onChange={handleChange}
            placeholder="Provide feedback (optional)"
          ></textarea>
        </label>
        <button
            type="submit"
            className="submit-button"
            disabled={isSubmitting}
          >
            {isSubmitting ? "Submitting..." : "Submit Ticket"}
        </button>

      </form>
    </div>
  );
};

export default SidePanel;
